/**
 * SRC error code names, from the AquaLogic 500 & GO Controller UI v230 appendix
 * ("12 Appendix: Error codes").
 *
 * The valve payload carries `errorCode` and `errorName`, the same pair the
 * stations list renders as "Code: N - name". This table is the fallback for
 * when the API sends a code without a name — it does not replace it.
 */
export const SRC_ERROR_CODE_NAMES: Record<number, string> = {
  1000: 'Two-wire timeout',
  1001: 'Two-wire communication error',
  1002: 'Two-wire not operational',
  1003: 'Two-wire load too high',
  2000: 'Object not found',
  2001: 'Object exists',
  3000: 'Line unit failure detected',
  3001: 'Line unit not acknowledged',
  4000: 'File deletion failed',
  4001: 'File write error',
  5000: 'IO config not found',
  5001: 'Flow capacity too low',
  6001: 'Value not measured',
  7000: 'Flow verify timeout',
  7001: 'Flow learn timeout',
  7002: 'Flow too low',
  7003: 'Flow too high',
}

export const errorCodeName = (code?: number | null): string =>
  SRC_ERROR_CODE_NAMES[Number(code)] ?? ''
